import httpService from "../../Service/httpService";

const controller = "Consultas";

export const getHorarios = async (id, fecha) => {
  const res = await httpService.get(
    `/${controller}/getHorarios/${id}/${fecha}`,
  );
  return res.data;
};

export const getPaciente = async (id, tel) => {
  const res = await httpService.get(`/${controller}/getPaciente/${id}/${tel}`);
  return res.data;
};

export const getPacienteXNombre = async (id) => {
  const res = await httpService.get(`/${controller}/getPacienteXNombre/${id}`);
  return res.data;
};

export const getServiciosConsultorio = async (id) => {
  const res = await httpService.get(`/${controller}/getServicios/${id}`);
  return res.data;
};

export const getTipoDoc = async (id) => {
  const res = await httpService.get(`/${controller}/getTipoDoc/${id}`);
  return res.data;
};

export const getMedicos = async (id) => {
  const res = await httpService.get(`/${controller}/getMedicos/${id}`);
  return res.data;
};

export const getExpedienteAnterior = async (id, idPac) => {
  const res = await httpService.get(`/${controller}/getExpedAnterior/${id}/${idPac}`);
  return res.data;
};

export const getIMC = async (imc) => {
  const res = await httpService.get(`/${controller}/getEstadoIMC/${imc}`);
  return res.data;
};

//getExistePaciente
export const getExistePaciente = async (id, telefono, nombre) => {
  const res = await httpService.get(`/${controller}/getExistePaciente/${id}/${telefono}/${nombre}`);
  return res.data;
};

export const getAntecedentesPaciente = async (id, idPac) => {
  const res = await httpService.get(`/${controller}/getAntecedentes/${id}/${idPac}`);
  return res.data;
};

export const getListaCitasPaciente = async (id, idPac) => {
  const res = await httpService.get(`/${controller}/getListaCitas/${id}/${idPac}`);
  return res.data;
};

export const getDatosCitaMedica = async (id, idPac, fecha) => {
  const res = await httpService.get(`/${controller}/getDatosCita/${id}/${idPac}/${fecha}`);
  return res.data;
};

export const getItemsExploraFis = async (id) => {
  const res = await httpService.get(`/${controller}/getItemsExploraFis/${id}`);
  return res.data;
};

export const getDocumentosCita = async (id, idConsulta) => {
  const res = await httpService.get(`/${controller}/getDocsCita/${id}/${idConsulta}`);
  return res.data;
};

export const getMedicosLab = async (id) => {
  const res = await httpService.get(`/${controller}/getMedicosLab/${id}`);
  return res.data;
};

export const getListaPacientes = async (id) => {
  const res = await httpService.get(`/${controller}/getListaPacientes/${id}`);
  return res.data;
};

export const getTelefonoXID = async (id, idPac, nombre) => {
  const res = await httpService.get(
    `/${controller}/getTelefonoXID/${id}/${idPac}/${nombre}`,
  );
  return res.data;
};

export const getCitas = async (id, date, estatus) => {
  const res = await httpService.get(
    `/${controller}/getCitas/${id}/${date}/${estatus}`,
  );
  return res.data;
};

export const getConsultorio = async (id, idMedico) => {
  const res = await httpService.get(
    `/${controller}/getConsultorio/${id}/${idMedico}`,
  );
  return res.data;
};

// GET Datos Cita Anterior
export const getDatosCitaAnterior = async (id, idPac, idAnteced) => {
  const res = await httpService.get(`/${controller}/getDatosCitaAnterior/${id}/${idPac}/${idAnteced}`);
  return res.data;
}

export const getSpConsultaLabHistorico = async (id, idPac) => {
  const res = await httpService.get(`/${controller}/getSpConsultaLabHistorico/${id}/${idPac}`);
  return res.data;
};

export const getGruposLabHistorico = async (id, idPac) => {
  const res = await httpService.get(`/${controller}/getGruposLabHistorico/${id}/${idPac}`);
  return res.data;
};

export const getResultLabsPaciente = async (id, idMedico, idPac) => {
  const res = await httpService.get(`/${controller}/getResultLabsPaciente/${id}/${idMedico}/${idPac}`);
  return res.data;
};

export const getProximaConsulta = async (id) => {
  const res = await httpService.get(`/${controller}/getProximaConsulta/${id}`);
  return res.data;
};

export const getDatosConsulta = async (id, nombre, telefono, hora) => {
  const res = await httpService.get(`/${controller}/getDatosConsulta/${id}/${nombre}/${telefono}/${hora}`);
  return res.data;
};

export const getTablaCitas = async (id, desde, hasta) => {
  const res = await httpService.get(`/${controller}/getTablaCitas/${id}/${desde}/${hasta}`);
  return res.data;
};


export const saveDatosInit = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveDatosInit`, {
		...data,
	});
	return res;
};

export const saveFieldDatos = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveFieldDatos`, {
		...data,
	});
	return res;
};

//saveItem
export const saveItem = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveItem`, {
		...data,
	});
	return res;
};

export const guardarCobro = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/guardarCobro`, {
		...data,
	});
	return res;
};

export const saveCita = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/save`, {
    ...data,
  });
  return res;
};

export const saveConfirmacion = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveConfirmacion`, {
    ...data,
  });
  return res;
};

export const saveCancelCita = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/cancelarCita`, {
    ...data,
  });
  return res;
};

export const saveUpdateCita = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/updateCita`, {
    ...data,
  });
  return res;
};

export const addMarcador = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/addMarcador`, {
		...data,
	});
	return res;
};

export const saveDoc = async (formData) => {
  try {
    const response = await httpService.post(`/${controller}/saveDoc`, formData, {
      headers: {
        // Axios automatically sets the correct Content-Type for FormData,
        // but explicitly setting it to multipart/form-data can also work
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

export const saveConsulta = async (formData) => {
  try {
    const response = await httpService.post(`/${controller}/saveConsulta`, formData, {
      headers: {
        // Axios automatically sets the correct Content-Type for FormData,
        // but explicitly setting it to multipart/form-data can also work
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};

